import MessageTabListComponent from "./MessageTabListComponent";

export default MessageTabListComponent;
